module.exports = __webpack_public_path__ + "img/share-icon.d63ef3a9.svg";